import { OrganizationNameType } from '@/common/enums/OrganizationNameType';
import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-event-business-issues-table',
	templateUrl: './event-business-issues-table.component.html',
	styleUrls: ['./event-business-issues-table.component.css'],
})
export class EventBusinessIssuesTableComponent extends ListComponent {
	protected itemsBeforeDataLoad = 5;
	protected apiUrl = 'eventBusinessIssuesTable';
	sum = 0;
	data: Array<any> = [];
	pageSizeOptions: number[] = [50, 100, 200];
	parameters: any = {
		date_from: null,
		date_to: null,
		due_from: null,
		due_to: null,
		yesno: [
			{ id: '0', name: 'Nie' },
			{ id: '1', name: 'Tak' },
		],
		date: [],
		statusNames: [
			{ id: '30', name: 'Wstępne' },
			{ id: '31', name: 'Potwierdzone' },
			{ id: '35', name: 'Zakończony' },
			{ id: '36', name: 'Rozliczony' },
		],
		documentTypes: [
			{ id: '1', name: 'Faktura' },
			{ id: '2', name: 'Proforma' },
			{ id: '3', name: 'Bez' },
		],
		owners: [],
		settled: [],
		organization: [],
		profile: [],
		get_organization_name: OrganizationNameType.RETURN_NAME,
	};
	filters;
	tableRows = [
		{ col: 'newId', header: 'Id', size: '80' },
		{ col: 'eventName', header: 'Wydarzenie', size: '420' },
		{ col: 'date_from', header: 'Data od', size: '80' },
		{ col: 'date_to', header: 'Data do', size: '80' },
		{ col: 'statusName', header: 'Status', size: '80' },
		{ col: 'ownersName', header: 'Opiekun', size: '140' },
		{ col: 'due', header: 'Termin płatności', size: '80' },
		{ col: 'value', header: 'Kwota', size: '60' },
		{ col: 'currencyName', header: 'Waluta', size: '60' },
		{ col: 'paymentMethodName', header: 'Sposób płatności', size: '80' },
		{ col: 'documentTypeName', header: 'Dokument', size: '80' },
		{ col: 'date', header: 'Data dokumentu', size: '120' },
		{ col: 'seller', header: 'Sprzedawca', size: '120' },
		{ col: 'settled', header: 'Pozostało do zapłaty', size: '140' },
		{ col: 'clientEvent', header: 'Klient', size: '140' },
	];
	sumElements = 0;
	sumValue = 0;

	sumAgreementPLN = 0;
	sumAgreementEUR = 0;
	sumSettledPLN = 0;
	sumSettledEUR = 0;

	protected loadBefore(): void {
		this.api.get('/eventBusinessParameters', (result) => {
			this.parameters = {
				...this.parameters,
				...result.data,
				get_organization_name: OrganizationNameType.RETURN_NAME,
			};
			this.loadData();
		});
		this.api.get('/users', (result) => {
			this.parameters.owners = result.data;
			this.loadData();
		});
		this.bag.get('/organization/short_name/?limit=9999', (result) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.organization = result.results;
			this.loadData();
		});
		this.bag.get('/profile/data/?limit=99999', (result) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.profile = result.results;
			this.loadData();
		});
	}

	protected convertData(data: any) {
		this.sumAgreementPLN = 0;
		this.sumAgreementEUR = 0;
		this.sumSettledPLN = 0;
		this.sumSettledEUR = 0;
		data.forEach((obj) => {
			obj.ownersName = '';
			obj.owners.forEach((owner) => {
				obj.ownersName += owner.name + ',';
			});
			const paymentMethod = this.parameters.paymentMethods.find((objFind) => objFind.id == obj.paymentMethod);
			obj.paymentMethodName = paymentMethod ? paymentMethod.name : '?';
			const documentType = this.parameters.documentTypes.find((objFind) => objFind.id == obj.documentType);
			obj.documentTypeName = documentType ? documentType.name : '(brak)';
			obj.clientEvent = this.findEventClient(obj);
			obj.seller = obj.organization && obj.organization_name ? obj.organization_name : '';
		});
		data.forEach((obj) => {
			if (obj.currencyName == 'PLN') {
				this.sumAgreementPLN += parseFloat(obj.value);
			} else {
				this.sumAgreementEUR += parseFloat(obj.value);
			}
		});
		data.forEach((obj) => {
			if (obj.currencyName == 'PLN') {
				this.sumSettledPLN += parseFloat(obj.settled);
			} else {
				this.sumSettledEUR += parseFloat(obj.settled);
			}
		});
		return data;
	}

	protected findEventClient(obj) {
		if (obj.clientEvent?.isOrganization === '1') {
			return this.findObject(this.parameters.organization, obj.clientEvent?.client)?.shortName;
		}
		if (obj.clientEvent?.isOrganization === '0') {
			obj.clientEvent = this.findObject(this.parameters.profile, obj.clientEvent?.client);
			return obj.clientEvent?.firstName + ' ' + obj.clientEvent?.lastName;
		}
	}

	protected findObject(arr, item) {
		return arr?.find((objfind) => objfind.id === item);
	}

	filtersSelected(data): void {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-15);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+15);
		}
		this.loadData();
	}
}
